import Glide from '@glidejs/glide';
import { indexOf } from 'lodash';

export default function (el) {
  if (!el) return;

  const scrollWidth = document.querySelector('body').scrollWidth;
  const maxContentWidth = (1140 - 48);

  const glide = new Glide(el, {
    type: 'carousel',
    gap: scrollWidth > maxContentWidth ? 24 : 0,
    peek: scrollWidth > maxContentWidth ? Math.ceil((scrollWidth - Math.min(maxContentWidth, scrollWidth - 48)) / 2) : 0,
  });

  const ActiveClasses = function (Glide, Components, Events) {
    const Component = {
      enableTransition() {
        const glideEl = Components.Html.root;
        const allSlides = glideEl.getElementsByClassName('glide__slide');

        allSlides.forEach(slide => {
          slide.classList.remove('glide__slide--no-transition')
        })
      },
      disableTransition() {
        const glideEl = Components.Html.root;
        const allSlides = glideEl.getElementsByClassName('glide__slide');

        allSlides.forEach(slide => {
          slide.classList.add('glide__slide--no-transition')
        })
      },
      setActiveClasses(props = {}, isBefore = false) {
        const glideEl = Components.Html.root;
        const allSlides = glideEl.getElementsByClassName('glide__slide');

        let activeSlideIndex = indexOf(allSlides, Components.Html.slides[glide.index])

        if (isBefore) {
          activeSlideIndex = props.direction === '>' ? activeSlideIndex + 1 : activeSlideIndex - 1;
        }

        const activeSlide = allSlides[activeSlideIndex];
        const prevSlide = activeSlide.previousElementSibling;
        const nextSlide = activeSlide.nextElementSibling;

        activeSlide.classList.remove('glide__slide--before-active', 'glide__slide--after-active');
        if (nextSlide) {
          nextSlide.classList.add('glide__slide--after-active');
          nextSlide.classList.remove('glide__slide--before-active');
        }
        if (prevSlide) {
          prevSlide.classList.add('glide__slide--before-active');
          prevSlide.classList.remove('glide__slide--after-active');
        }
      },
      mount() {
        this.setActiveClasses();
      },

    }
    Events.on(['run.before'], (props) => {
      // Before the transition is made
      Component.setActiveClasses(props, true);
    });
    Events.on('run.offset', () => {
      // After the transition has happened between switching the clone for the first or last
      Component.enableTransition();
    });
    Events.on('translate.jump', () => {
      // Before the transition has happened between switching the clone for the first or last
      Component.disableTransition();
      Component.setActiveClasses();
    })
    return Component;
  }

  const targets = el.querySelectorAll('[data-slide-role="target"]');
  glide.on(['run', 'build.after'], function () {
    targets.forEach(target => {
      target.dataset.slideState = target.dataset.slideIndex == glide.index ? 'active' : 'passive';
    })
  })

  glide.mount({
    ActiveClasses,
  });
}
